module.exports = __webpack_public_path__ + "img/icon_left_bet.2718be4c.svg";